// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/review_service.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Review, ReviewStatus } from "./review_pb.ts";

/**
 * @generated from message protogen.CreateReviewRequest
 */
export class CreateReviewRequest extends Message<CreateReviewRequest> {
  /**
   * @generated from field: string submitterRef = 1;
   */
  submitterRef = "";

  /**
   * @generated from field: string subjectRef = 2;
   */
  subjectRef = "";

  /**
   * @generated from field: optional string displayName = 3;
   */
  displayName?: string;

  /**
   * @generated from field: string text = 4;
   */
  text = "";

  /**
   * @generated from field: float starCount = 5;
   */
  starCount = 0;

  /**
   * @generated from field: protogen.ReviewStatus status = 6;
   */
  status = ReviewStatus.UNSPECIFIED;

  constructor(data?: PartialMessage<CreateReviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateReviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "submitterRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subjectRef", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "displayName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "starCount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "status", kind: "enum", T: proto3.getEnumType(ReviewStatus) },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReviewRequest {
    return new CreateReviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReviewRequest {
    return new CreateReviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReviewRequest {
    return new CreateReviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReviewRequest | PlainMessage<CreateReviewRequest> | undefined, b: CreateReviewRequest | PlainMessage<CreateReviewRequest> | undefined): boolean {
    return proto3.util.equals(CreateReviewRequest, a, b);
  }
}

/**
 * @generated from message protogen.CreateReviewResponse
 */
export class CreateReviewResponse extends Message<CreateReviewResponse> {
  /**
   * @generated from field: protogen.Review review = 1;
   */
  review?: Review;

  constructor(data?: PartialMessage<CreateReviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.CreateReviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "review", kind: "message", T: Review },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateReviewResponse {
    return new CreateReviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateReviewResponse {
    return new CreateReviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateReviewResponse {
    return new CreateReviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: CreateReviewResponse | PlainMessage<CreateReviewResponse> | undefined, b: CreateReviewResponse | PlainMessage<CreateReviewResponse> | undefined): boolean {
    return proto3.util.equals(CreateReviewResponse, a, b);
  }
}

/**
 * @generated from message protogen.ListReviewsRequest
 */
export class ListReviewsRequest extends Message<ListReviewsRequest> {
  /**
   * @generated from field: optional string subjectRef = 1;
   */
  subjectRef?: string;

  /**
   * @generated from field: optional protogen.ReviewStatus status = 2;
   */
  status?: ReviewStatus;

  constructor(data?: PartialMessage<ListReviewsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListReviewsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subjectRef", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ReviewStatus), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListReviewsRequest {
    return new ListReviewsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListReviewsRequest {
    return new ListReviewsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListReviewsRequest {
    return new ListReviewsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: ListReviewsRequest | PlainMessage<ListReviewsRequest> | undefined, b: ListReviewsRequest | PlainMessage<ListReviewsRequest> | undefined): boolean {
    return proto3.util.equals(ListReviewsRequest, a, b);
  }
}

/**
 * @generated from message protogen.ListReviewsResponse
 */
export class ListReviewsResponse extends Message<ListReviewsResponse> {
  /**
   * @generated from field: repeated protogen.Review reviews = 1;
   */
  reviews: Review[] = [];

  constructor(data?: PartialMessage<ListReviewsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.ListReviewsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "reviews", kind: "message", T: Review, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ListReviewsResponse {
    return new ListReviewsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ListReviewsResponse {
    return new ListReviewsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ListReviewsResponse {
    return new ListReviewsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: ListReviewsResponse | PlainMessage<ListReviewsResponse> | undefined, b: ListReviewsResponse | PlainMessage<ListReviewsResponse> | undefined): boolean {
    return proto3.util.equals(ListReviewsResponse, a, b);
  }
}

/**
 * @generated from message protogen.AdminListReviewsRequest
 */
export class AdminListReviewsRequest extends Message<AdminListReviewsRequest> {
  /**
   * @generated from field: optional string subjectRef = 1;
   */
  subjectRef?: string;

  /**
   * @generated from field: optional protogen.ReviewStatus status = 2;
   */
  status?: ReviewStatus;

  constructor(data?: PartialMessage<AdminListReviewsRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListReviewsRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "subjectRef", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(ReviewStatus), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListReviewsRequest {
    return new AdminListReviewsRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListReviewsRequest {
    return new AdminListReviewsRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListReviewsRequest {
    return new AdminListReviewsRequest().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListReviewsRequest | PlainMessage<AdminListReviewsRequest> | undefined, b: AdminListReviewsRequest | PlainMessage<AdminListReviewsRequest> | undefined): boolean {
    return proto3.util.equals(AdminListReviewsRequest, a, b);
  }
}

/**
 * @generated from message protogen.AdminListReviewsResponse
 */
export class AdminListReviewsResponse extends Message<AdminListReviewsResponse> {
  /**
   * @generated from field: repeated protogen.Review reviews = 1;
   */
  reviews: Review[] = [];

  constructor(data?: PartialMessage<AdminListReviewsResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.AdminListReviewsResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "reviews", kind: "message", T: Review, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): AdminListReviewsResponse {
    return new AdminListReviewsResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): AdminListReviewsResponse {
    return new AdminListReviewsResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): AdminListReviewsResponse {
    return new AdminListReviewsResponse().fromJsonString(jsonString, options);
  }

  static equals(a: AdminListReviewsResponse | PlainMessage<AdminListReviewsResponse> | undefined, b: AdminListReviewsResponse | PlainMessage<AdminListReviewsResponse> | undefined): boolean {
    return proto3.util.equals(AdminListReviewsResponse, a, b);
  }
}

/**
 * @generated from message protogen.UpdateReviewRequest
 */
export class UpdateReviewRequest extends Message<UpdateReviewRequest> {
  /**
   * @generated from field: string ref = 1;
   */
  ref = "";

  /**
   * @generated from field: optional string displayName = 2;
   */
  displayName?: string;

  /**
   * @generated from field: optional string text = 3;
   */
  text?: string;

  /**
   * @generated from field: optional float starCount = 4;
   */
  starCount?: number;

  /**
   * @generated from field: optional protogen.ReviewStatus status = 5;
   */
  status?: ReviewStatus;

  constructor(data?: PartialMessage<UpdateReviewRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateReviewRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ref", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "displayName", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 4, name: "starCount", kind: "scalar", T: 2 /* ScalarType.FLOAT */, opt: true },
    { no: 5, name: "status", kind: "enum", T: proto3.getEnumType(ReviewStatus), opt: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReviewRequest {
    return new UpdateReviewRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReviewRequest {
    return new UpdateReviewRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReviewRequest {
    return new UpdateReviewRequest().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReviewRequest | PlainMessage<UpdateReviewRequest> | undefined, b: UpdateReviewRequest | PlainMessage<UpdateReviewRequest> | undefined): boolean {
    return proto3.util.equals(UpdateReviewRequest, a, b);
  }
}

/**
 * @generated from message protogen.UpdateReviewResponse
 */
export class UpdateReviewResponse extends Message<UpdateReviewResponse> {
  /**
   * @generated from field: protogen.Review review = 1;
   */
  review?: Review;

  constructor(data?: PartialMessage<UpdateReviewResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.UpdateReviewResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "review", kind: "message", T: Review },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateReviewResponse {
    return new UpdateReviewResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateReviewResponse {
    return new UpdateReviewResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateReviewResponse {
    return new UpdateReviewResponse().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateReviewResponse | PlainMessage<UpdateReviewResponse> | undefined, b: UpdateReviewResponse | PlainMessage<UpdateReviewResponse> | undefined): boolean {
    return proto3.util.equals(UpdateReviewResponse, a, b);
  }
}

